import { defineStore } from "pinia";
import { ref } from "vue";
import { getMenuList } from "@/common/api/sys-mng/MenuAPi";

// 인터페이스는 여기서 export 하여 다른 곳에서도 쓸 수 있게 합니다.
export interface MenuItem {
  menuId: string;
  upMenuId?: string;
  name: string;
  url: string;
  orderNo?: number;
  children?: MenuItem[];
  useYn?: string;
}

export const useMenuStore = defineStore("menu", () => {
  // State
  const menuItems = ref<MenuItem[]>([]);
  const isLoaded = ref(false); // 데이터가 이미 로드되었는지 체크
  
  let fetchPromise: Promise<void> | null = null;
  // Action
  const fetchMenus = async () => {
    // 이미 데이터가 있다면 재호출 방지 (필요에 따라 제거 가능)
    if (isLoaded.value && menuItems.value.length > 0) return;
    
    if (fetchPromise) {
      await fetchPromise;
      return;
    }

    fetchPromise = (async () => {
      try {
        const response = await getMenuList();
        if (Array.isArray(response)) {
          menuItems.value = response;
        } else if (response && Array.isArray(response.data)) {
          menuItems.value = response.data;
        }
        isLoaded.value = true;
      } catch (error) {
        console.error("전역 메뉴 조회 실패:", error);
      } finally {
        fetchPromise = null; // 작업 끝나면 초기화
      }
    })();

    await fetchPromise;
  };

  return {
    menuItems,
    isLoaded,
    fetchMenus,
  };
});